import React, { useState, useEffect } from "react";
import headers from "../../Data/Tables/Report/headers";
import Header from "../../Componets/Header";
import Menus from "../../Componets/Menus";
import ProductIcon from "../../Assets/Svg/products";
import InventoryIcon from "../../Assets/Svg/inventory";
import BillingIcon from "../../Assets/Svg/billing";
import SalesIcon from "../../Assets/Svg/sales";
import PurchaseIcon from "../../Assets/Svg/purchase";
import ExpenseIcon from "../../Assets/Svg/expense";
import CustomerIcon from "../../Assets/Svg/customer";
import SupplierIcon from "../../Assets/Svg/supplier";
import ScrollWrapper from "../../Componets/ScrollWrapper";
import {
  SolutionOutlined,
} from "@ant-design/icons";
import FeatureLockWrapper from "../../Componets/FeatureLocksWrapper";
import FeatureUnlockRequestModal from "../../Componets/FeatureRequestMailForm";
import TradePartnerIcon from "../../Assets/Svg/tradepartner";
import { get_user_auth } from "../../Controllers/Layouts/Layouts";


const Reports = () => {
  const [header, setHeader] = useState(headers);
  const [authorizeMail, setAuthorizeMail] = useState(false);
  const [canaryMail, setCanaryMail] = useState(false);

  const formdata = async (data) => {
    console.log(data);
  };

  const lockedReports = {
    "supplier_wise_purchase": {
      name: "Supplier-wise Purchase Report",
      featureKey: "supplier_purchase_report"
    },
    "cash_closing": {
      name: "Cash Closing Report",
      featureKey: "cash_closing_report"
    },
    "transaction": {
      name: "Transaction Report",
      featureKey: "transaction_report"
    },
    "stock_ledger": {
      name: "Stock Ledger",
      featureKey: "stock_ledger"
    },
    "customer_sales_return": {
      name: "Customer-wise Sales & Returns Report",
      featureKey: "customer_sales_return_report"
    },
    "product_ageing": {
      name: "Product Ageing",
      featureKey: "product_ageing"
    },
    "received_ageing": {
      name: "Received Ageing",
      featureKey: "received_ageing"
    },
    "fast_moving": {
      name: "Fast Moving Items",
      featureKey: "fast_moving"
    },
    "top_selling": {
      name: "Top Selling Products",
      featureKey: "top_selling"
    },
    "vat_summary": {
      name: "VAT Summary",
      featureKey: "vat_summary"
    },
    "transfer_report": {
      name: "Transfer Report",
      featureKey: "transfer_report"
    },
    "received_order_report": {
      name: "Received Order Report",
      featureKey: "received_order_report"
    },
    "trade_partner_ledger": {
      name: "Trade Partner Ledger",
      featureKey: "trade_partner_ledger"
    },
    "consolidated_sales": {
      name: "Consolidated Sales",
      featureKey: "consolidated_sales"
    }
  };

  const menu = [
    {
      icon: <ProductIcon />,
      name: "Products stock",
      description: "View products report",
      url: "/app/reports/products",
    },
    {
      icon: <ProductIcon />,
      name: "Products low stock",
      description: "View products low stock report",
      url: "/app/reports/products/low/stock",
    },
    {
      icon: <ProductIcon />,
      name: "Products out of stock",
      description: "View products out of stock report",
      url: "/app/reports/products/out/of/stock",
    },
    /* {
      icon: <ProductIcon />,
      name: "Products fast moving",
      description: "View products fast moving report",
      url: "/app/reports/products/fast/moving",
    }, */
    {
      icon: <ProductIcon />,
      name: "Products top selling",
      description: "View products top selling report",
      url: "/app/reports/products/top/selling",
      isLocked: true,
      featureKey: lockedReports.top_selling.featureKey
    },
    {
      icon: <ProductIcon />,
      name: "Products ageing",
      description: "View products ageing reports",
      url: "/app/reports/products/ageing",
      isLocked: true,
      featureKey: lockedReports.product_ageing.featureKey
    },
    {
      icon: <ProductIcon />,
      name: "Products received ageing",
      description: "View products received ageing reports",
      url: "/app/reports/products/received/ageing",
      isLocked: true,
      featureKey: lockedReports.received_ageing.featureKey
    },
    {
      icon: <ProductIcon />,
      name: "Products Fast Moving reports",
      description: "View products fast moving report",
      url: "/app/reports/products/reports",
      isLocked: true,
      featureKey: lockedReports.fast_moving.featureKey
    },

    // {
    //   icon: <ProductIcon />,
    //   name: "Product sold",
    //   description: "View product sale report",
    //   url: "/app/reports/products/sold",
    // },
    // {
    //   icon: <ProductIcon />,
    //   name: "Product purchase",
    //   description: "View product purchase report",
    //   url: "/app/reports/products/purchase",
    // },

    {
      icon: <InventoryIcon />,
      name: "Inventory",
      description: "View inventory report",
      url: "/app/reports/inventory",
    },
    {
      icon: <InventoryIcon />,
      name: "Inventory near expiry",
      description: "View inventory near expiry report",
      url: "/app/reports/inventory/near/expiry",
    },
    {
      icon: <InventoryIcon />,
      name: "Inventory expired",
      description: "View inventory expired report",
      url: "/app/reports/inventory/expired",
    },
    {
      icon: <InventoryIcon />,
      name: "Transfers report",
      description: "View transfer report",
      url: "/app/reports/transfers",
      isLocked: true,
      featureKey: lockedReports.transfer_report.featureKey
    },
    {
      icon: <BillingIcon />,
      name: "Sales VAT",
      description: "View sales tax report",
      url: "/app/reports/sales/vat",
    },
    {
      icon: <BillingIcon />,
      name: "Purchase VAT",
      description: "View purchase tax report",
      url: "/app/reports/purchase/vat",
    },
    {
      icon: <BillingIcon />,
      name: "VAT Summary",
      description: "View tax summary report",
      url: "/app/reports/summary/vat",
      isLocked: true,
      featureKey: lockedReports.vat_summary.featureKey
    },

    {
      icon: <SalesIcon />,
      name: "Sales",
      description: "View sales report",
      url: "/app/reports/sales",
    },
    {
      icon: <SalesIcon />,
      name: "Sales Return",
      description: "View sales return report",
      url: "/app/reports/sales-return",
    },
    {
      icon: <SalesIcon />,
      name: "Net Sales",
      description: "View net sales report",
      url: "/app/reports/sales/net",
    },

    {
      icon: <PurchaseIcon />,
      name: "Purchases",
      description: "View purchases report",
      url: "/app/reports/purcases",
    },
    {
      icon: <PurchaseIcon />,
      name: "Purchase Returns",
      description: "View purchase returns report",
      url: "/app/reports/purchase-returns",
    },
    {
      icon: <SupplierIcon />,
      name: "Supplier-wise Purchase Report",
      description: "View products purchased from each supplier",
      url: "/app/reports/supplier-wise-purchase",
      isLocked: true,
      featureKey: lockedReports.supplier_wise_purchase.featureKey
    },
    {
      icon: <ExpenseIcon />,
      name: "Expenses",
      description: "View expenses report",
      url: "/app/reports/expenses",
    },
    {
      icon: <ExpenseIcon />,
      name: "Cash Closing Report",
      description: "View Daily Cash Closures report",
      url: "/app/reports/cashClosing",
      isLocked: true,
      featureKey: lockedReports.cash_closing.featureKey
    },

    {
      icon: <ExpenseIcon />,
      name: "Transaction Report",
      description: "View Daily Sales  report",
      url: "/app/reports/dailySales",
      isLocked: true,
      featureKey: lockedReports.transaction.featureKey
    },
    {
      icon: <ExpenseIcon />,
      name: "Received Orders Report",
      description: "View Received Orders report",
      url: "/app/reports/receivedorders",
      isLocked: true,
      featureKey: lockedReports.received_order_report.featureKey
    },

    {
      icon: <SolutionOutlined />,
      name: "Customer-wise Sales & Returns Report",
      description: "View Customer-wise Sales & Returns with Payment Status Report",
      url: "/app/reports/customer-wise-sale-and-return",
      isLocked: true,
      featureKey: lockedReports.customer_sales_return.featureKey
    },
    {
      icon: <SolutionOutlined />,
      name: "Stock Ledger",
      description: "View Stock Ledger Report",
      url: "/app/reports/stock-ledger",
      isLocked: true,
      featureKey: lockedReports.stock_ledger.featureKey
    },
    {
      icon: <TradePartnerIcon />,
      name: "Trade Partner Ledger",
      description: "View combined purchase & sales ledger for linked partners",
      url: "/app/reports/trading-partner",
      isLocked: true,
      featureKey: lockedReports.trade_partner_ledger.featureKey
    },
    {
      icon: <SalesIcon />,
      name: "Consolidated Sales",
      description: "View consolidated daily sales report",
      url: "/app/reports/consolidated-sales",
      isLocked: true,
      featureKey: lockedReports.consolidated_sales.featureKey
    },

    // {
    //   icon: <CustomerIcon />,
    //   name: "Customer",
    //   description: "View customer report",
    //   url: "/app/reports/customers",
    // },
    // {
    //   icon: <SupplierIcon />,
    //   name: "Suppliers",
    //   description: "View suppliers report",
    //   url: "/app/reports/suppliers",
    // },
  ];

  const [selectedFeature, setSelectedFeature] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLockedClick = (e, feature) => {
    e.preventDefault();
    setSelectedFeature(feature);
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchAuthorizeUser();
  }, []);

  const fetchAuthorizeUser = async () => {
    try {
      const response = await get_user_auth();
      if (response?.status) {
        const authorize_email = response?.data?.branch?.plan === 3000 &&
          response?.data?.email?.trim().toLowerCase() ===
          process.env.REACT_APP_CROWN_PHARMACY_EMAIL?.trim().toLowerCase();

        const canary_email =
          response?.data?.email?.trim().toLowerCase() ===
          process.env.REACT_APP_CANARY_PHARMACY_EMAIL?.trim().toLowerCase();

        setAuthorizeMail(authorize_email);
        setCanaryMail(canary_email);  // ADD THIS
      }

      console.log("Authorization check:", response?.data, process.env.REACT_APP_CROWN_PHARMACY_EMAIL)
    } catch (error) {
      console.error("Auth check failed:", error);
    }
  };

  const filteredMenu = React.useMemo(() => {
    return menu.filter((item) => {
      if (item.url === "/app/reports/trading-partner") {
        return authorizeMail;
      }
      if (item.url === "/app/reports/consolidated-sales") {
        return canaryMail;
      }
      return true;
    });
  }, [authorizeMail, canaryMail]);


  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <ScrollWrapper summary={2}>
        <div className="mt-4 grid grid-cols-4 gap-4">
          {filteredMenu.map((value, index) => {
            if (value.isLocked) {
              return (
                <FeatureLockWrapper
                  featureKey={value.featureKey}
                  onClick={handleLockedClick}
                >
                  <Menus
                    className="relative flex bg-white p-4 rounded-lg border cursor-pointer setting-card hover:bg-gray-100"
                    icon={value?.icon}
                    name={value?.name}
                    description={value?.description}
                    url={value?.url}
                  />
                </FeatureLockWrapper>
              );
            } else {
              return (
                <Menus
                  key={index}
                  className="flex bg-white p-4 rounded-lg border cursor-pointer setting-card hover:bg-gray-100"
                  icon={value?.icon}
                  name={value?.name}
                  description={value?.description}
                  url={value?.url}
                />
              );
            }
          })}
        </div>
        {selectedFeature && (
          <FeatureUnlockRequestModal
            isOpen={isModalOpen}
            onClose={() => {
              setIsModalOpen(false);
              setSelectedFeature(null);
            }}
            feature={selectedFeature}
            onSuccess={() => {
              console.log("Feature unlocked successfully!");
            }}
          />
        )}
      </ScrollWrapper>
    </Header>
  );
};

export default Reports;
